<template lang="pug">
md-layout()
  md-layout(md-flex='85')
    md-input-container(:class='{ "md-input-invalid" : formSubmitted && !file && status === "public"}')
      label  {{label}}
      md-file(v-model='fileName', accept='image/*', @selected='onFileSelected')
      span.md-error(v-if='formSubmitted && !validFormat') You must select a valid image (the valid ones are: JPG, JPEG, BMP, PNG)
      span.md-error(v-else-if='formSubmitted && !file') This field is required
    span.md-error.error-message(:style="{ color: '#ff5722'}", v-if="imgErrorShowText") {{imgErrorText}}
  md-layout(md-flex='15')
    .uploader
      md-button.md-fab(@click='upload', :class="{ 'md-primary': done }", :disabled='!file || imgErrorShowText')
        md-icon(v-if='!done', md-iconset="fa fa-cloud-upload-alt")
        md-icon(v-if='done', md-iconset="fa fa-check")
      md-theme(md-name='blue', v-if='progress > 0 && !done')
        md-spinner(:md-size='74', :md-stroke='2.2', :md-progress='progress')
</template>

<script>
  import uploadService from '../../services/uploadService';
  import { validImageFormat } from '../../common/utils/formatValidation'

  export default {
    props: {
      label: {
        type: String,
        default: 'File'
      },
      imageFileName: {
        type: String
      },
      accountID: {
        type: String
      },
      formSubmitted: {
        type: Boolean,
        required: true
      },
      validations: {
        type: Object,
        required: true
      },
      isVideoThumbnail: {
        type: Boolean,
        default: false,
      },
      status: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        fileName: this.imageFileName,
        file: null,
        progress: 0,
        done: false,
        uploading: false,
        validFormat: true,
        imgErrorText:'',
        imgErrorShowText: false,
        isValidSize: false,
      };
    },
    computed: {
      uploadDisabled() {
        return this.uploading || this.done;
      }
    },
    methods: {
      async onFileSelected(files) {
        const isValidSize = await this.verifyWidhtAndHeight(files[0]);
        this.isValidSize = isValidSize;
        this.validFormat = validImageFormat(files[0].name);

        if (!this.validFormat){
          this.file = null;
          return
        }

        if (this.isVideoThumbnail) {
          const myNewFile = new File([files[0]], 'uploaded', {type: files[0].type});
          this.file = myNewFile;
          return
        }


        this.file = files[0];
      },
      async upload() {
        if (!this.uploadDisabled && this.validFormat) {
          this.uploading = true;
          const measureValidation = await this.verifyWidhtAndHeight(this.file);
          if(measureValidation)
          {
            uploadService.uploadImage(this.file, this, this.accountID)
            .then((path) => {
              this.done = true;
              const mimeType = this.file.type;
              this.$emit('uploadSuccess', { url: `${path}`, mimeType });
              setTimeout(() => {
                // this.file = null;
                this.progress = 0;
                this.done = false;
                this.uploading = false;
                this.validFormat = true;
              }, 3000);
            })
            .catch(() => {
              this.$emit('uploadFailed');
              setTimeout(() => {
                this.resetUploader();
              }, 3000);
            })
            .then(() => {
              this.uploading = false;
            });
          } else{
            this.$emit('uploadFailed');
            setTimeout(() => {
              this.resetUploader();
            }, 3000);
          }
        }
      },
      async verifyWidhtAndHeight(file){
        return new Promise((resolve, reject) => {
          //Verify images for roku
          let result = false;
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e) =>{
            var image = new Image();
            image.src = e.target.result;
            image.onload = () =>{
              let height = image.height;
              let width = image.width;
              result = width >= 800 && height >=450;
              if (result) {
              this.imgErrorShowText = false;
              } else {
                this.imgErrorText = `The image must have a minimum size of 800x450.`;
                this.imgErrorShowText = true;
              }
              resolve(result);
            }
          }
          reader.onerror = (e) =>{
            reject('Error with file upload');
          }
        })
      },
      resetUploader() {
        this.fileName = this.imageFileName;
        this.file = null;
        this.progress = 0;
        this.done = false;
        this.uploading = false;
      }
    },
    watch: {
      imageFileName(newVal) {
        this.fileName = newVal;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .uploader {
    margin: 0 auto;
    width: 56px;
    height: 56px;
    position: relative;
    .md-fab {
      margin: 0;
    }
    .md-spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .md-icon {
      margin: 0 !important;
      top: 50%;
      left: 47% !important;
      transform: translate(-50%, -50%);
    }
  }
  .error-message{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/upload/ImageUploader.vue